<template>
  <div>
    <slot></slot>
    <p v-if="objectModelTrigger.linked_form_id">
      Auto-generate
      <a :href="RouteHelper.path({route: Route.editForm, modelOrId: objectModelTrigger.linked_form_id})" class="btn-link">
        {{objectModelTrigger.linked_form_title}}
      </a>
    </p>

  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import triggerBaseMixin from "../mixins/trigger-base-mixin";
  import {RouteHelper} from "../../../common/helpers/routeHelper";
  import {Route} from "~/enums/route";

  export default Vue.extend({
    components: {},
    mixins: [
      triggerBaseMixin,
    ],
    computed:{

    },
    methods:{

    },
    data: function() {
      return {
        RouteHelper,
        Route,

      };
    },
  });
</script>